import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { System } from './../../shared-components/System';
import { ReportCardGradesTerm, CurriculumMarkTypes, CategoryAverage } from './grades.model';
import {SharedService} from '../../shared-components/shared.service';

@Injectable({
    providedIn: 'root'
})
export class GradesService {

    constructor(
        private http: HttpClient,
        private sharedService: SharedService
    ) { }

    // getReportCardTerms
    getReportCardTerms(siteYearId: number, IsprogressGrades: boolean, blnIncludeTerms: boolean): Observable<ReportCardGradesTerm[]> {
        let queryString = '';
        queryString += '?SiteYearId=' + siteYearId +
            '&IsprogressGrades=' + IsprogressGrades +
            '&blnIncludeTerms=' + blnIncludeTerms;
        return this.http.get<ReportCardGradesTerm[]>(System.apiURL.Student + 'GetReportCardTerms' + queryString);
    }

    // getCurriculumMarkTypesReadForSubject
    getCurriculumMarkTypesReadForSubject(siteSectionId: number): Observable<CurriculumMarkTypes[]> {
        return this.sharedService.getCurriculumMarkTypesReadForSubject(siteSectionId);
    }

    // getStudentCategoryAverage
    getStudentCategoryAverage(studentId: number, yearId: number): Observable<CategoryAverage[]> {
        let queryString = '';
        queryString += '?studentId=' + studentId +
            '&yearId=' + yearId;
        return this.http.get<CategoryAverage[]>(System.apiURL.Student + 'GetStudentCategoryAverage' + queryString);
    }

    getReportCardBehaviorSocialSkillDescription(siteYearId: number): Observable<string> {
        let queryString = '';
        queryString += '?siteYearId=' + siteYearId;
        return this.http.get<string>(System.apiURL.Student + 'GetReportCardBehaviorSocialSkillDescription' + queryString);
    }
}
